import { render, staticRenderFns } from "./faultStatistics.vue?vue&type=template&id=dfbb7f0e&scoped=true"
import script from "./faultStatistics.vue?vue&type=script&lang=js"
export * from "./faultStatistics.vue?vue&type=script&lang=js"
import style0 from "./faultStatistics.vue?vue&type=style&index=0&id=dfbb7f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb7f0e",
  null
  
)

export default component.exports